import { InputType, IOnChangeInputValueHandlerProps } from '../types';
import { stringTransform } from 'src/utils/helpers';
import { floatNumbersValidation, numberValidation } from 'src/utils/validation';

export const onChangeInputValueHandler = ({
  event,
  disableRemoveUnnecessaryZeros,
  type,
  isNumberType,
  maxLength,
  onChangeValue,
}: IOnChangeInputValueHandlerProps) => {
  let value: string = event.target.value;

  // if clear input
  if (!value.trim().length) {
    onChangeValue(undefined);
    return;
  }

  if (!isNumberType) {
    onChangeValue(value);
    return;
  }

  // if type number or floatNumber
  value = stringTransform(value, disableRemoveUnnecessaryZeros);

  // if maxLength indicated
  if (maxLength && value.split('.').join('').length > maxLength) {
    return;
  }

  if (type === InputType.NUMBER) {
    if (!numberValidation(value)) return;
    onChangeValue(value);
    return;
  }

  if (type === InputType.FLOAT_NUMBER) {
    if (!floatNumbersValidation(value)) return;
    onChangeValue(value);
  }
};
